module.exports = __webpack_public_path__ + "static/img/1.a2e97a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/1.png
// module id = jAEc
// module chunks = 0